export default __webpack_public_path__ + "static/media/geometric.88b1690f.png";